<template>
	<v-row :class="rowClass">
		<v-col cols="12" class="pt-0">
			<div v-if="label !== ''" class="d-flex align-center">
				<div class="mr-auto">
					<v-card-title v-if="fieldType === 'textarea'" class="pl-0 pb-4 section-title">
						{{ label }}
					</v-card-title>
					<div v-if="fieldType === 'cost'" class="d-flex align-center">
						<div class="font-size-3 tnm-label" style="min-width: 100px">{{ label }}</div>
						<div class="pl-4 pr-4 flex-grow-1">
							<v-text-field
								ref="textfield"
								v-model="fieldValue"
								:name="field"
								prepend-inner-icon="mdi-currency-usd"
								:error="hasErrors(form, field)"
								:hide-details="! hasErrors(form, field)"
								:error-messages="errorMsg(form, field)"
								outlined />
						</div>
					</div>
				</div>
				<div v-if="hasCannedText">
					<v-menu offset-y>
						<template #activator="{ on, attrs }">
							<v-btn
								text
								left
								small
								color="primary"
								class="text-capitalize pr-2 pl-2 font-size-2"
								v-bind="attrs"
								v-on="on"
								@click="getCannedText(cannedTextName ?? fieldName)">
								Insert Canned Text
								<v-icon right>mdi-chevron-down</v-icon>
							</v-btn>
						</template>
						<v-list v-if="length(canned_text_data)" class="canned-text">
							<v-list-item
								v-for="(item, index) in canned_text_data"
								:key="index"
								@click="insertCannedText(item.canned_text, fieldValue)">
								<v-list-item-title>{{ item.canned_text_name }}</v-list-item-title>
							</v-list-item>
						</v-list>
						<v-list v-else class="text-center">
							<v-list-item-title class="grey--text px-5 py-3">No canned text available. Add a new one?</v-list-item-title>
						</v-list>
					</v-menu>
					<v-dialog v-model="dialogAddCannedText" transition="scroll-x-reverse-transition" max-width="600">
						<template #activator="{ on, attrs }">
							<v-btn
								text
								small
								class="text-capitalize pr-2 pl-2 font-size-2"
								color="success"
								v-bind="attrs"
								v-on="on">
								Add Canned Text
							</v-btn>
						</template>
						<template #default>
							<v-card>
								<v-card-title>
									<div>Add Canned Text</div>
									<v-icon right class="ml-auto theme--dark" @click="dialogAddCannedText = false">mdi-close</v-icon>
								</v-card-title>
								<v-divider class="mb-5" />
								<v-card-text>
									<canned-text-form :field="fieldName" @success="dialogAddCannedText = false" />
								</v-card-text>
							</v-card>
						</template>
					</v-dialog>
					<v-dialog v-model="dialogManageCannedText" transition="scroll-x-reverse-transition" max-width="1100">
						<template #activator="{ on, attrs }">
							<v-btn
								text
								small
								class="text-capitalize pr-0 pl-2 font-size-2"
								color="warning"
								v-bind="attrs"
								v-on="on"
								@click="getCannedText(fieldName)">
								Manage Canned Text
							</v-btn>
						</template>
						<template #default>
							<v-card>
								<v-card-title>
									<div>Manage Canned Text for '{{ label }}'</div>
									<v-icon right class="ml-auto theme--dark" @click="dialogManageCannedText = false">mdi-close</v-icon>
								</v-card-title>
								<v-card-text class="pa-0">
									<v-simple-table fixed-header class="tnm-simple-table" height="500px">
										<template #default>
											<thead>
												<tr>
													<th class="text-left pl-6">
														Name
													</th>
													<th class="text-left">
														Canned Text
													</th>
													<th></th>
												</tr>
											</thead>
											<tbody v-if="canned_text_data.length > 0">
												<tr
													v-for="item in canned_text_data"
													:key="item.id">
													<td style="vertical-align: top; min-width: 225px;" class="pl-6">
														<v-edit-dialog
															persistent
															large
															:return-value.sync="item.canned_text_name"
															@save="updateCannedText(item)">
															{{ item.canned_text_name | capitalize }}
															<template #input>
																<v-text-field
																	v-model="item.canned_text_name"
																	item-text="canned_text_name"
																	return-object
																	hide-details
																	single-line />
															</template>
														</v-edit-dialog>
													</td>
													<td style="vertical-align: top">
														<v-edit-dialog
															persistent
															large
															:return-value.sync="item.canned_text"
															@save="updateCannedText(item)">
															{{ item.canned_text }}
															<template #input>
																<v-textarea
																	v-model="item.canned_text"
																	item-text="canned_text"
																	return-object
																	hide-details
																	single-line />
															</template>
														</v-edit-dialog>
													</td>
													<td style="vertical-align: top">
														<delete-button
															x-small
															icon
															model="canned-text"
															:model-id="item.id"
															classes="float-right"
															@deleted="cannedTextDeleted(item.id)">
															<v-icon color="danger">
																mdi-delete
															</v-icon>
														</delete-button>
													</td>
												</tr>
											</tbody>
											<tbody v-else>
												<tr>
													<td colspan="3" class="text-center"><em>No canned text found for this field.</em></td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-card-text>
							</v-card>
						</template>
					</v-dialog>
				</div>
			</div>
			<editor
				v-if="fieldType === 'textarea'"
				:id="fieldName"
				ref="textfield"
				v-model="fieldValue"
				api-key="gpl"
				:error="hasErrors(form, field)"
				:hide-details="! hasErrors(form, field)"
				:error-messages="errorMsg(form, field)"
				:init="editorInit"></editor>
			<!--			<v-textarea-->
			<!--				v-if="fieldType === 'textarea' && isEditor === false"-->
			<!--				ref="textfield"-->
			<!--				v-model="fieldValue"-->
			<!--				:toolbar-attributes="{ color: '#5b9ccf', dark: 'dark' }"-->
			<!--				counter-->
			<!--				:error="hasErrors(form, field)"-->
			<!--				:hide-details="! hasErrors(form, field)"-->
			<!--				:error-messages="errorMsg(form, field)"-->
			<!--				outlined></v-textarea>-->
		</v-col>
	</v-row>
</template>
<script>

import api from '@/api'
import CannedTextForm from './CannedTextForm'
import _ from 'lodash'
import DeleteButton from '@/Pages/Backend/Components/DeleteButton'

import 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'
import 'tinymce/skins/ui/tinymce-5/skin.min.css'
import 'tinymce/skins/ui/tinymce-5/content.min.css'
import 'tinymce/plugins/advlist/plugin'
import 'tinymce/plugins/autolink/plugin'
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/charmap/plugin'
import 'tinymce/plugins/preview/plugin'
import 'tinymce/plugins/anchor/plugin'
import 'tinymce/plugins/searchreplace/plugin'
import 'tinymce/plugins/visualblocks/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/insertdatetime/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/wordcount/plugin'
import 'tinymce/plugins/autoresize/plugin'
import 'tinymce/models/dom'

import Editor from '@tinymce/tinymce-vue'

export default {
	components: { CannedTextForm, Editor, DeleteButton },
	props: {
		value: {
			type: String,
			default: () => ''
		},
		label: {
			type: String,
			default: ''
		},
		form: {
			type: Object,
			required: true
		},
		field: {
			type: String,
			required: true
		},
		fieldType: {
			type: String,
			default: 'textarea'
		},
		fieldName: {
			type: String,
			required: true
		},
		rowClass: {
			type: String,
			default: 'pt-5 pb-5'
		},
		isEditor: {
			type: Boolean,
			default: true
		},
		hasCannedText: {
			type: Boolean,
			default: true
		},
		cannedTextName: {
			type: String,
			default: null
		}
	},
	data () {
		return {
			canned_text_data: {},
			fieldValue: '',
			dialogAddCannedText: false,
			dialogManageCannedText: false,
			editorInit: {
				license_key: 'gpl',
				height: 150,
				plugins: [
					'advlist',
					'autolink',
					'lists',
					'link',
					'image',
					'charmap',
					'preview',
					'anchor',
					'searchreplace',
					'visualblocks',
					'code',
					'insertdatetime',
					'table',
					'wordcount',
					'autoresize'
				],
				toolbar:
					'undo redo | styles | bold italic underline | \
									   alignleft aligncenter alignright alignjustify | \
									   bullist numlist outdent indent | removeformat',
				menubar: false,
				browser_spellcheck: true,
				skin: false,
				content_css: false,
				content_style: '@import url(\'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;600;700&display=swap\'); ' +
					'body { margin: 1em; font-family: "Roboto", sans-serif; } ' +
					'p { margin-top: 0 !important; line-height: 1.3 !important; } + td ( padding: 5px; }',
				contextmenu: false,
				branding: false
			}
		}
	},
	watch: {
		value (newValue, prevValue) {
			if (newValue === '' || !newValue || newValue === prevValue) return
			this.fieldValue = newValue
		},
		fieldValue: {
			handler: _.debounce(function () {
				this.$emit('input', this.fieldValue)
			}, 100)
		}
	},
	mounted () {
		this.fieldValue = this.value
	},
	methods: {
		getCannedText (field) {
			const method = 'GET'
			const data = {}

			const url = this.route('canned-text.api.get', field)

			api({method, url, data}).then(response => {
				this.canned_text_data = response.data
			})
		},

		insertCannedText (text, value) {
			if (!text.length) return

			if (this.isEditor) {
				let editorId = this.$refs.textfield.elementId
				tinymce.get(editorId).insertContent( text)
			} else {

				let textfield = this.$refs.textfield.$refs.input
				const sentence = textfield.value
				const len = sentence.length
				let pos = textfield.selectionStart

				if (pos === undefined) {
					pos = 0
				}

				const before = sentence.substring(0, pos)
				const after = sentence.substring(pos, len)

				this.fieldValue = before + text + after

				this.$nextTick().then(() => {
					textfield.selectStart = pos + text.length
					textfield.focus()
				})
			}
		},

		updateCannedText (canned_text) {
			this.$inertia.put(this.route('canned-text.update',  canned_text.id), canned_text)
		},

		cannedTextDeleted (itemId) {
			const itemIndex = _.findIndex(this.canned_text_data, { id: itemId })
			this.$delete(this.canned_text_data, itemIndex)
		}
	}
}
</script>
